import React from 'react';
import { Header, SubHeader } from '../../style';
import { useMappingState } from '../tableMappingProvider';

interface TableMappingProps {
  show: boolean;
}

const ChooseUserIdentifier = (props: TableMappingProps) => {
  const { loading, ifUpdate, viewOnly } = useMappingState();

  if (!props.show) {
    return <div />;
  }
  if (!loading) {
    if (viewOnly || ifUpdate) {
      return (
        <div>
          <Header>User identifier</Header>
        </div>
      );
    }
    return (
      <div>
        <Header>Choose user identifier</Header>
        <SubHeader>Which columns should we use for user_id and/or anonymous_id</SubHeader>
      </div>
    );
  }

  return <div />;
};

export default ChooseUserIdentifier;
